export type Locale = 'en' | 'vi';

function isBlank(value: unknown): boolean {
  if (value === null || value === undefined) return true;
  if (typeof value === 'string') return value.trim() === '';
  if (Array.isArray(value)) return value.length === 0;
  if (typeof value === 'object') return Object.keys(value as object).length === 0;
  return false;
}

/**
 * Picks the Vietnamese value when the current language is 'vi' and it is present,
 * otherwise falls back to the English value.
 */
export function loc<T>(lang: Locale, en: T, vi: unknown): T {
  if (lang === 'vi' && !isBlank(vi)) return vi as T;
  return en;
}